import { render, staticRenderFns } from "./font-family.vue?vue&type=template&id=52585a60&"
import script from "./font-family.vue?vue&type=script&lang=js&"
export * from "./font-family.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports